import { JSONSchemaType } from 'ajv'

export interface IInvoiceFormData {
  id: string
  year: string
  month: string
  amount: number
  dueDate: string
  payDate?: string
  amountPaid: number
  commercialPlanId: string
  paymentGatewayId: string
  paymentTransaction: string
  paymentMethod: string
  paymentCurrency: string
}

const InvoiceSchema: JSONSchemaType<IInvoiceFormData> = {
  type: 'object',
  properties: {
    year: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    month: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    amount: {
      type: 'number',
      minimum: 0,
      default: 0,
      errorMessage: 'Campo obrigatório',
    },
    dueDate: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    payDate: {
      type: 'string',
      minLength: 1,
      nullable: true,
    },
    amountPaid: {
      type: 'number',
      default: 0,
    },
    id: {
      type: 'string',
    },
    commercialPlanId: {
      type: 'string',
    },
    paymentGatewayId: {
      type: 'string',
    },
    paymentTransaction: {
      type: 'string',
    },
    paymentMethod: {
      type: 'string',
    },
    paymentCurrency: {
      type: 'string',
    },
  },
  required: ['year', 'month', 'amount', 'dueDate'],
  additionalProperties: false,
}

export default InvoiceSchema
